import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Modal, Tooltip } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons';

const InfoModal = ({
  isOpen,
  buttons,
  showCheckIcon,
  showTopButtons,
  children,
  title,
  closable,
  onCancel,
  width = '467px'
}) => {
  const primaryButton = (
    <Button
      disabled={buttons.primary.isDisabled}
      type="primary"
      onClick={buttons.primary.onClick}>
      {buttons.primary.label}
    </Button>
  );

  // Wrap in span so Tooltip fires even when Button is disabled (antd swallows hover on disabled).
  const primaryWithTooltip = buttons.primary.tooltip ? (
    <Tooltip title={buttons.primary.tooltip}>
      <span>{primaryButton}</span>
    </Tooltip>
  ) : (
    primaryButton
  );

  const actionButtons = (
    <>
      {buttons.secondary && (
        <Button onClick={buttons.secondary.onClick}>
          {buttons.secondary.label}
        </Button>
      )}
      {primaryWithTooltip}
    </>
  );

  const modalTitle =
    showTopButtons && title ? (
      <StyledTitleRow>
        <span>{title}</span>
        <StyledTitleButtons>{actionButtons}</StyledTitleButtons>
      </StyledTitleRow>
    ) : (
      title
    );

  return (
    <Modal
      visible={isOpen}
      centered
      closable={closable}
      width={width}
      title={modalTitle}
      onCancel={onCancel}
      // FIN-10450: When showTopButtons is true, hide footer buttons to avoid duplication
      footer={showTopButtons ? null : actionButtons}>
      <StyledDiv>
        {showCheckIcon && (
          <div>
            <CheckCircleTwoTone
              twoToneColor="#52c41a"
              width="21px"
              height="21px"
            />
          </div>
        )}
        <StyledChildrenDiv>{children}</StyledChildrenDiv>
      </StyledDiv>
    </Modal>
  );
};

const StyledTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 24px;
`;

const StyledTitleButtons = styled.div`
  display: flex;
  gap: 8px;
`;

const StyledDiv = styled.div`
  display: flex;
`;
const StyledChildrenDiv = styled.div`
  margin-left: 17.5px;
  width: 100%;
`;

const ButtonType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  tooltip: PropTypes.string
});

InfoModal.propTypes = {
  isOpen: PropTypes.bool,
  buttons: PropTypes.shape({
    primary: ButtonType.isRequired,
    secondary: ButtonType
  }),
  showCheckIcon: PropTypes.bool,
  showTopButtons: PropTypes.bool,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  closable: PropTypes.bool,
  onCancel: PropTypes.func
};

InfoModal.defaultProps = {
  isOpen: false,
  showCheckIcon: true,
  closable: false,
  buttons: {
    primary: {
      label: 'OK',
      onClick: () => {}
    }
  }
};

export default InfoModal;
